export const MEMBERSHIP_PRICE = "39.99";

export const COMPLIMENTARY_SERVICES = [
  "Standard Oil Change",
  "Tire Rotation",
  "Battery Test",
  "Charging System Test",
  "Brake Inspection",
  "Multi-Point Inspection",
  "Seasonal Vehicle Inspection",
  "Fluid Inspection and Top Off",
  "Cabin Air Filter Installation (customer purchases filter)",
  "Engine Air Filter Installation (customer purchases filter)",
  "Windshield Wiper Installation",
];

export const MEMBER_BENEFITS = [
  "One complimentary maintenance service every 12 months — your choice from eligible services",
  "10% off eligible labor",
  "Priority scheduling",
  "Maintenance reminders",
  "Digital vehicle history",
  "Exclusive promotions",
  "Member pricing",
  "Preferred customer support",
  "Service records",
];

export const COMPARISON = [
  {
    key: "non-member",
    title: "Non-Member",
    price: "$0",
    period: "no membership",
    highlight: false,
    savings: null,
    features: [
      "Standard service rates",
      "Standard scheduling",
      "No annual complimentary service",
      "No labor discounts",
      "Pay per visit",
    ],
  },
  {
    key: "member",
    title: "Member",
    price: "$39.99",
    period: "per month",
    highlight: true,
    savings: "Est. annual savings: $150–$300+",
    features: [
      "One complimentary maintenance service / 12 months",
      "10% off eligible labor",
      "Priority scheduling",
      "Maintenance reminders & digital vehicle history",
      "Exclusive member promotions & pricing",
      "Preferred customer support",
    ],
  },
];

export const AUTHORIZATION_TEXT =
  "I authorize Mason's Mobile Mechanic to charge the payment method provided $39.99 today and $39.99 each month thereafter until I cancel my membership. I understand that my membership will automatically renew monthly and that I may cancel future renewals through the available customer billing portal or by contacting Mason's Mobile Mechanic. Cancellation stops future charges but does not provide a refund or prorated credit for amounts already paid.";

export const BILLING_DISCLOSURES = [
  "You will be charged $39.99 upon enrollment.",
  "Your payment method will be charged automatically every month on or near your original enrollment date.",
  "Your membership continues until canceled.",
  "Cancellation applies to future billing periods.",
  "Payments already processed are nonrefundable and are not prorated.",
  "Membership benefits end when the paid membership period expires.",
  "The complimentary annual maintenance service is available only to active members and is subject to eligibility, scheduling, service-area limitations, and the applicable membership terms.",
  "Mason's Mobile Mechanic may update membership benefits or pricing with advance notice as required by applicable law.",
  "You may update your payment method, view billing information, or cancel through the Stripe customer portal from your Member Portal.",
];

export const EXCLUSIONS_NOTE =
  "Parts, specialty fluids, taxes, disposal fees, diagnostic work, emergency services, and other excluded services may cost extra. Discounts cannot be combined with other promotions unless approved by Mason's Mobile Mechanic.";

export const MEMBERSHIP_FAQ = [
  {
    q: "What is included in the complimentary annual service?",
    a: "Each 12 months of active membership, you choose ONE eligible service: standard oil change, tire rotation, battery test, charging system test, brake inspection, multi-point inspection, seasonal vehicle inspection, fluid inspection & top off, cabin or engine air filter installation (you purchase the filter), or windshield wiper installation.",
  },
  {
    q: "How does the 10% labor discount work?",
    a: "Active members receive 10% off eligible labor on standard services. Parts, specialty fluids, taxes, disposal fees, diagnostics, and emergency services are excluded. Discounts can't be combined with other promotions unless approved by Mason's Mobile Mechanic.",
  },
  {
    q: "When am I billed?",
    a: "You're charged $39.99 when you enroll, then automatically every month on or near your original enrollment date until you cancel.",
  },
  {
    q: "How do I cancel?",
    a: "Any time — from your Member Portal via the secure Stripe billing portal, or by contacting us. Cancellation stops future charges; payments already processed are nonrefundable and not prorated. Benefits remain active until your paid period ends.",
  },
  {
    q: "Is my payment information safe?",
    a: "Yes. All payments are processed by Stripe on their secure hosted checkout. We never see or store your card details.",
  },
  {
    q: "Does the membership cover multiple vehicles?",
    a: "Your membership is per household account and the complimentary annual service applies to one vehicle per year. You can store unlimited vehicles in your portal garage.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve the entire Las Vegas Valley — Las Vegas, North Las Vegas, Henderson, Summerlin, Spring Valley, Enterprise, Paradise, and surrounding areas.",
  },
];

export const AGREEMENT_SECTIONS = [
  {
    title: "1. Membership Overview",
    body: "Mason's Mobile Membership is a monthly vehicle care membership offered by Mason's Mobile Mechanic ('we', 'us'). The membership costs $39.99 per month and renews automatically each month until canceled.",
  },
  {
    title: "2. Benefits",
    body: "Active members receive: one complimentary maintenance service every 12 months (member chooses one eligible service), 10% off eligible labor, priority scheduling, maintenance reminders, digital vehicle history, exclusive promotions, member pricing, preferred customer support, and service records. Eligible complimentary services: Standard Oil Change, Tire Rotation, Battery Test, Charging System Test, Brake Inspection, Multi-Point Inspection, Seasonal Vehicle Inspection, Fluid Inspection and Top Off, Cabin Air Filter Installation (customer purchases filter), Engine Air Filter Installation (customer purchases filter), Windshield Wiper Installation.",
  },
  {
    title: "3. Exclusions",
    body: "Parts, specialty fluids, taxes, disposal fees, diagnostic work, emergency services, and other excluded services may cost extra and are not covered by the membership. Membership discounts cannot be combined with other promotions unless approved by Mason's Mobile Mechanic.",
  },
  {
    title: "4. Recurring Billing",
    body: "By enrolling, you authorize Mason's Mobile Mechanic to charge your payment method $39.99 upon enrollment and $39.99 each month thereafter on or near your original enrollment date, until you cancel. All payments are processed securely by Stripe; we never store your card details.",
  },
  {
    title: "5. Cancellation",
    body: "You may cancel future renewals at any time through the Stripe customer billing portal (available in your Member Portal) or by contacting Mason's Mobile Mechanic. Cancellation stops future charges but does not provide a refund or prorated credit for amounts already paid. Benefits end when the paid membership period expires.",
  },
  {
    title: "6. Complimentary Service Eligibility",
    body: "The complimentary annual maintenance service is available only while your membership is active and payments are current. It is limited to one redemption per rolling 12-month period, is subject to scheduling availability and our service area, and has no cash value. Filters for filter-installation services must be purchased by the member.",
  },
  {
    title: "7. Failed Payments",
    body: "If a monthly payment fails, we may retry the charge and will notify you. Member benefits, including member pricing and the complimentary service, may be suspended while the account is past due and terminated if payment is not resolved.",
  },
  {
    title: "8. Changes to the Program",
    body: "Mason's Mobile Mechanic may update membership benefits or pricing with advance notice as required by applicable law. Continued membership after notice constitutes acceptance of the updated terms.",
  },
  {
    title: "9. Service Terms",
    body: "All services performed under the membership remain subject to our standard Terms of Service and Repair Authorization, available on this website.",
  },
  {
    title: "10. Contact",
    body: "Questions about your membership? Call or text (404) 749-7063 or email info@masonsmobile.com.",
  },
];

export const CANCELLATION_SECTIONS = [
  {
    title: "How to Cancel",
    body: "Cancel any time through the Stripe customer billing portal — open your Member Portal and choose 'Manage Billing' — or by contacting Mason's Mobile Mechanic at (404) 749-7063 or info@masonsmobile.com.",
  },
  {
    title: "When Cancellation Takes Effect",
    body: "Cancellation applies to future billing periods. Your membership and benefits remain active until the end of the period you have already paid for.",
  },
  {
    title: "Refunds",
    body: "Payments already processed are nonrefundable and are not prorated. Canceling stops future charges only.",
  },
  {
    title: "Benefits After Cancellation",
    body: "Member benefits — including member pricing and the complimentary annual service — end when your paid membership period expires. Unredeemed complimentary services have no cash value and expire with the membership.",
  },
  {
    title: "Rejoining",
    body: "You're welcome back any time. Rejoining starts a new enrollment date and a new 12-month complimentary service window.",
  },
];
